import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'sub-capability',
  templateUrl: './sub-capability.component.html',
  styleUrls: ['./sub-capability.component.sass']
})
export class SubCapabilityComponent implements OnInit {
  @Input() name: string;
  @Input() content: string;
  
  constructor() { }

  ngOnInit() {
  }

}
